import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntTypeTransport } from "../../../../models/handBooks/typeTransport";
import SelectTransportCategory from "../../../../components/selects/SelectTransportCategory";
import i18n from "i18next";
import { aliasText } from "../../../../utils";

enum FormField {
    alias,
    transportCategoryId,
    nameRu,
    nameKy,
    category

}

interface IProps {
    show: boolean;
    typeTransport: EntTypeTransport;
    onHide: () => void;
    onSubmit: (pos: EntTypeTransport) => Promise<boolean>;
}

export const AddTypeTransportModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.transportCategoryId, value: props.typeTransport.category?.id },
            { name: FormField.alias, value: props.typeTransport.alias },
            { name: FormField.nameKy, value: props.typeTransport.nameKy },
            { name: FormField.nameRu, value: props.typeTransport.nameRu },
        ]);
    }

    const setEntityFromFields = (): EntTypeTransport => {
        let typeTransport = _.cloneDeep(props.typeTransport);
        typeTransport.transportCategoryId = form.getFieldValue(FormField.transportCategoryId);
        typeTransport.alias = form.getFieldValue(FormField.alias);
        typeTransport.nameKy = form.getFieldValue(FormField.nameKy);
        typeTransport.nameRu = form.getFieldValue(FormField.nameRu);
        return typeTransport;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={ props.typeTransport.id === 0 ? t('handbooks.type_transport.add_type_transport') : t('handbooks.type_transport.edit_type_transport') }
                visible={ props.show }
                onCancel={ props.onHide }
                onSubmit={ handleSubmit }
                submitLoading={ loading }
            >
                <Form
                    initialValues={ { remember: true } }
                    autoComplete="off"
                    layout="vertical"
                    form={ form }
                >
                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={ t('general.nameKy') }
                        name={ FormField.nameKy }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameRu') }
                        name={ FormField.nameRu }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                    <Form.Item
                        label={ t('titles.transport_category') }
                        name={ FormField.transportCategoryId }
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                    >
                        <SelectTransportCategory/>
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>

    )
}
